"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ManagerLayout = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var ManagerLayout = function ManagerLayout(_ref) {
  var Header = _ref.Header,
    Navigation = _ref.Navigation,
    children = _ref.children,
    className = _ref.className,
    contentClassName = _ref.contentClassName,
    headerClassName = _ref.headerClassName,
    navigationClassName = _ref.navigationClassName;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(className, 'relative')
  }, /*#__PURE__*/_react.default.createElement("header", {
    className: (0, _classnames.default)(headerClassName, 'fixed w-full top-0 h-app-header-height z-app-header bg-white border-0 border-b-[1px] border-solid border-grey-15')
  }, Header), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(navigationClassName, 'relative float-left z-[102] h-full min-h-screen')
  }, Navigation), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(contentClassName, 'LayoutContent', 'relative overflow-auto top-app-header-height h-[calc(100vh-theme(spacing.app-header-height))] bg-grey-10')
  }, children));
};
exports.ManagerLayout = ManagerLayout;